import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  claimDetails: [],
  claimDetailsId: null,
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_CLAIM_DETAILS:
      let getclaimVal = Object.keys(action.claimDetails)[0];
      if (state.claimDetails.length != 0) {
        let main = state?.claimDetails?.forEach(function (obj) {
          delete obj[getclaimVal];
        });
      }
      return {
        ...state,
        claimDetails: [...state.claimDetails, action.claimDetails],
      };
    case actionTypes.CLAIM_DETAILS_ID:
      return { ...state, claimDetailsId: action.payload };
    default:
      return state;
  }
};

export default reducer;
